import { QueryFunctionContext } from 'react-query';
import { baseQuery } from '../baseQuery';
import type { Service } from 'types';

export const getService = async ({ queryKey }: QueryFunctionContext<[string, string]>) => {
  const { data } = await baseQuery(`service/${queryKey[1]}`);

  return data as Service;
};
